import { router } from "@inertiajs/vue3"
import { computed, ref } from "vue"

import { containerPath, itemPath } from "@/routes"
import type { ItemDetail } from "@/types/models"

export function useDeleteItem(item: ItemDetail) {
  const deleteModalOpen = ref(false)
  const deleting = ref(false)
  const reassignTo = ref<string | undefined>(undefined)
  const reparentMode = ref<"up" | "move">("up")

  const childCount = item.child_count ?? 0

  const deleteDisabled = computed(
    () => childCount > 0 && reparentMode.value === "move" && !reassignTo.value,
  )

  function openDelete() {
    reparentMode.value = "up"
    reassignTo.value = undefined
    deleteModalOpen.value = true
  }

  function confirmDelete() {
    deleting.value = true
    const data: Record<string, string> = {}

    if (childCount > 0) {
      if (reparentMode.value === "move" && reassignTo.value) {
        data.reassign_to = reassignTo.value
      } else {
        data.confirmed = "1"
      }
    }

    if (item.is_container) {
      router.delete(containerPath(item.id), {
        data,
        onFinish: () => (deleting.value = false),
      })
    } else {
      router.delete(itemPath(item.id), {
        data,
        onFinish: () => (deleting.value = false),
      })
    }
  }

  return {
    deleteModalOpen,
    deleting,
    reassignTo,
    reparentMode,
    childCount,
    deleteDisabled,
    openDelete,
    confirmDelete,
  }
}
